export default __webpack_public_path__ + "static/media/Eszter_homepage.73a3e1a0.png";